import script from "./ProductsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductsPage.vue?vue&type=style&index=0&id=66042df7&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/vue-data-provider/vue-data-provider/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66042df7"]])

export default __exports__